import mixinFlexItem from './mixin-flex-item'

export default {
  mixins: [
    mixinFlexItem
  ],
  props: {
    flex: {
      type: [String, Object],
      default: null
    },
    inline: {
      type: [Boolean, Object],
      default: false
    },
    direction: {
      type: [String, Object],
      default: null
    },
    wrap: {
      type: [Boolean, String, Object],
      default: null
    },
    items: {
      type: [String, Object],
      default: null
    },
    content: {
      type: [String, Object],
      default: null
    },
    justify: {
      type: [String, Object],
      default: null
    }
  },
  vessel: {
    default: {
      $flex: 'flex',
      $direction: 'flexDirection',
      $wrap: 'flexWrap',
      $items: 'flexItems',
      $content: 'flexContent',
      $justify: 'flexJustify',
      $inline: {
        display(value) {
          return value ? 'inline-flex' : 'flex'
        }
      }
    }
  }
}
